import VTable from '@/vuetify_custom/v-table/v3'
import { formattingNumber } from '@/libs/util.js'
import styles from '../../index.module.less'
import mixIns from '../../mixIns.jsx'
import { getGroupFinanceStatementMonthlyLedgerQueryApi } from '../../service'
import { illegalityData } from '../../utils'
import { VBtn } from 'vuetify/lib'
import {go_target_key_table} from '../../constants'
export default {
    mixins: [mixIns],
    props: {
        loading:{
            type: Boolean,
            default:() => false
        },
        params: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            records: [],
            record_hash: {},
            get_loading: false,
        }
    },
    computed: {
        window_width() {
            return this.$store.state.window_width
        },
        records_c() {
            return this.records.filter(item => item.show)
        },
        assembly_headers() {
            const _this = this
            return [
                {
                    level: 1,
                    rowspan: 2,
                    text: '',
                    align: 'center',
                    value: 'title',
                    fixed: 'left',
                    width: 250,
                    z_index:8,
                    h_class: styles['td-h-r'],
                    render:(...params) => {
                        return this.titleRemder(...params, _this)
                    }
                }
            ].concat(this.cwgkTableHeader)
        }
    },
    created() {
        // 截流处理
      
    },
    mounted() {
       //  this.setRecords()
    },
    methods: {
        itemRender({target, keys, go_target}) {
            target = target || {}
            const unit = this.params.unit
            const val = target[keys[0]] && target[keys[0]][keys[1]]
            const color = Number(val) < 0 ? 'red' : ''
            if (target.not_data_show) {
                return 
            }
            if (Number(target.val) === 20 && target['1']) {
                return <span>{formattingNumber(target['1'].ending_balance, 4, 100)}</span>
            }
            if (illegalityData(val)) {
                return <span>-</span>
            }
           
            if (go_target) {
                
                return <span style="cursor: pointer;color: #1976d2" on={{
                    click:() => {
                        const {path, ...query} = go_target
                        this.$emit('go')
                        localStorage.setItem(go_target_key_table, JSON.stringify(this.records))
                        this.$router.push({path: path, query})
                    }
                }}>{formattingNumber(val / unit, 2)}</span>
            }
            // 银行流水-差异金额 
            // if() {

            // }

            return <span style={{color}}>{formattingNumber(val / unit, 2)}</span>
        },
        getDataProxy() {
            this.get_loading = true
            getGroupFinanceStatementMonthlyLedgerQueryApi({
                month: this.params.month,
            }).then(res => {
                this.setRecords(res || [])
            }).catch(() => {
                this.setRecords([])
            }).finally(() => {
                this.get_loading = false
            })
        },
        tableHeader() {
            const headers = this.assembly_headers
            return <thead
                        class="v-data-table-header"
                    >
                    <tr class={styles['header-tr']}>
                        {headers.filter(item => item.level === 1).map(item => {
                            return <th 
                                colspan={item.colspan || 1}
                                rowspan={item.rowspan || 1}
                                role="columnheader"
                                style={{
                                   'min-width': item.width + 'px',
                                    'text-align': item.align,
                                    
                                }}
                                class={[item.h_class, styles['custom-bg']].join(' ')}
                            >{item.title} </th>
                        })}
                    </tr>
                     <tr class={styles['header-tr']}>
                        {headers.filter(item => item.level === 2).map(item => {
                            return <th role="columnheader"
                                class={[item.h_class, styles['custom-bg']].join(' ')}
                                style={{
                                    'min-width': item.width + 'px',
                                    'text-align': item.align
                                }}
                            >{item.title}</th>
                        })}
                    </tr>
        </thead>
        },
        titleRemder(t, target = {}) {
            const _this = this
            return <div 
                        class={target.style}
                    >
                    {target.has_click && <VBtn 
                        x-small
                        text
                        on-click={() => {
                            target.is_open = !target.is_open
                            if (target.children) {
                                target.children.forEach(key => {
                                    _this.record_hash[key].show = target.is_open
                                })
                            }
                        }}
                    >
                        <Icon type={target.is_open ? 'ios-arrow-down' : 'ios-arrow-forward'}/>
                    </VBtn>} {t}
                </div>
        },
        setRecords(res) {
            let data = this.cwgk()
            let records_c = localStorage.getItem(go_target_key_table)
            if (records_c) {
                records_c = JSON.parse(records_c)
                localStorage.removeItem(go_target_key_table)
                this.records = records_c instanceof Array && records_c || []
            }
            if (this.records && this.records.length) {
                data = this.records.map((item, index) => {
                    return Object.keys(data[index]).reduce((total, key) => {
                        total[key] = item[key]
                        return total
                    }, {})
                })
            }
            let res_hash = {}
            const records = []
            const record_hash = {}
            if (res && res.length) {
                res_hash = res.reduce((total, item) => {
                    if (!total[item.data_type]) {
                        total[item.data_type] = {}
                    }
                    total[item.data_type][item.statement_type] = item
                    return total
                }, {})
            }
            data.forEach((item) => {
                const res_cur_item = res_hash[item.val] || {}
                const cur_item = {
                    ...item,
                    ...res_cur_item
                }
                records.push(cur_item)
                record_hash[item.val] = cur_item
            });
            this.records = records
            this.record_hash = record_hash
        }
    },
    render() {
        return <div class={styles['general']}>
            <VTable
               ref="table"
               no-data-text="暂无数据"
               headers={this.assembly_headers.filter(item => !!item.value)}
               desserts={this.records_c}
               loading={this.get_loading}
               rowClass={({value}) => {
                   return value.tr_style || ''
               }}
               scopedSlots={{
                    header:this.tableHeader,
               }}
            />
        </div>
    }
}